import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import Modal from '../common/Modal/Modal';

/**
 * Button to open the Log your inputs modal.
 * Modal is rendered via createPortal to overlay the full screen.
 */
export default function LogInputs(_props: RegistryComponentProps): React.ReactElement {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => {
    setShowModal(false);
    document.body.style.overflow = 'auto';
  };

  return (
    <>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center', padding: '8px 0' }}>
        <button
          onClick={() => setShowModal(true)}
          className="btn-primary noscroll-recalculate-all-button"
          style={{
            marginTop: '10px',
          }}
        >
          Log your inputs
        </button>
      </div>

      {showModal &&
        createPortal(
          <Modal
            title="Log your inputs"
            onClose={handleClose}
            size="small"
            transparentBackdrop={true}
            parameterStyle={true}
          >
            <div style={{ padding: '20px', textAlign: 'center' }}>
              <p style={{ color: '#d32f2f', fontSize: '16px', fontWeight: '500' }}>
                Not logged in to OceanOS account
              </p>
            </div>
          </Modal>,
          document.body
        )}
    </>
  );
}
